export default "__VITE_ASSET__DeZsgmnj__"